import React, { useState, lazy, Suspense, useEffect } from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from 'mdb-react-ui-kit';
import LoadingOverlay from "../../../Components/LoadingOverlay";
import PopConfirm from "../../../Components/PopConfirm";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import { encryptData } from "../../../Utilities/CryptoUtility";
import Toast from "../../../Components/Toast";
import FileRename from "../Views/FileRename";
import AddUser from "../Views/Administrator/AddUser";
import UserHistory from "../Views/Administrator/UserHistory";
import { SecureStorage } from '../../../Utilities/StorageEncryption';
const UserAction = ({index, filename, portal, actionParams, getUploadData, onEditUser, onRefreshData }) => {
    const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false);
    const [isConfirmDeleteFileModalOpen , setIsConfirmDeleteFileModalOpen] = useState(false);
    const [isConfirmDeleteUserModalOpen , setIsConfirmDeleteUserModalOpen] = useState(false);
    const [isConfirmForgotPasswordModalOpen, setIsConfirmForgotPasswordModalOpen] = useState(false);
    const [isConfirmLockUnlockModalOpen, setIsConfirmLockUnlockModalOpen] = useState(false);
    const [isUserHistoryModalOpen, setIsUserHistoryModalOpen] = useState(false);
    const [fileNameWithoutExtension, setFileNameWithoutExtension] = useState(filename);
    const [fileExtension, setFileExtension] = useState(actionParams?.fileExtension);

    useEffect(() => {
        setFileExtension(actionParams?.fileExtension);
        setFileNameWithoutExtension(filename);
    }, [filename]);
    const [toastData, setToastData] = useState({ type: "", message: "", isOpen: false });
    const [portalType, setPortalType] =  useState(portal);
    const { makeApiCall } = useAxiosCall();
    const [isRenameFileModalOpen, setIsRenameFileModalOpen] = useState(false);
    const [renameValue, setRenameValue] = useState("");

    const handleDeleteUserOpen = () => {
        setIsDeleteUserModalOpen(true);
    };

    const handleDeleteUserClose = () => {
        setIsDeleteUserModalOpen(false);
    };

    const handleApiCallSuccess = (data) => {
        setToastData({ type: "success", message: data.message, isOpen: true, position: 'top-right' });
        getUploadData();
        handleModalClose()
    }

    const handleDownloadFileApiCallSuccess = (data, headers) => {

        const contentType = headers.get('Content-Type');
        try {
            const blob = new Blob([data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename+fileExtension;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setToastData({ type: "success", message: "File downloaded successfully.", isOpen: true, position: 'top-right' });
          } catch (error) {
            console.error('Error handling API call success:', error);
            setToastData({ type: "danger", message: "Something went wrong.", isOpen: true, position: 'top-right' });
        }
    }

    const handleApiCallError = (errorMessage) => {
        setToastData({ type: "danger", message: errorMessage, isOpen: true, position: 'top-right' });
    };

    const resetToastData = () => {
        setToastData({ type: "", message: "", isOpen: false });
    }

    const onConfirmDeleteUser = async () => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    portal: portal,
                    userType: "siteadmin",
                    customer: SecureStorage.getItem('acctDbKey')
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'resetUserPassword'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }
    const onConfirmUnlockUser = async () => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    portal: portal,
                    userType: "siteadmin",
                    customer: SecureStorage.getItem('acctDbKey')
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'resetUserPassword'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }
    const onConfirmlockUser = async () => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    portal: portal,
                    userType: "siteadmin",
                    customer: SecureStorage.getItem('acctDbKey')
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'resetUserPassword'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }

    const editUser = () => {
        if (onEditUser && actionParams?.username) {
            onEditUser(actionParams.username);
        }
    }
    const deleteUser = () => {
        setIsConfirmDeleteUserModalOpen(true);
        
    }
    const userHistory = () => {
        setIsUserHistoryModalOpen(true);
    }
    const forgotPassword = () => {
        setIsConfirmForgotPasswordModalOpen(true);
    }
    const unlockUser = () => {
        setIsConfirmLockUnlockModalOpen(true);
    }
    const deleteFileService = async() => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    filename: filename+fileExtension
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'deleteFile'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }
    const updateFile = async(newfilename) => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    filename: filename+fileExtension,
                    newfilename: newfilename+fileExtension,
                }
            ))
        }
        try {
            await makeApiCall({
                requestData,
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'renameFile'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }
    const forgotPasswordReset  = () => {
        console.log("reset forgot password here")
    }
    const lockUnlockUser = () => {
        console.log("lock unlock user here")
    }
    // close all model from here
    const handleModalClose = () => {
        setIsConfirmDeleteFileModalOpen(false);
        setIsRenameFileModalOpen(false);
        setIsConfirmDeleteUserModalOpen(false);
        setIsConfirmForgotPasswordModalOpen(false);
        setIsEditUserModalOpen(false);
        setIsConfirmLockUnlockModalOpen(false);
        setIsUserHistoryModalOpen(false);
    };
    const deleteFileModal = () => {
        setIsConfirmDeleteFileModalOpen(true);
    }
    const downloadFile = async() => {
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    filename: filename+fileExtension
                }
            ))
        }

        try {
            await makeApiCall({
                requestData,
                onSuccess: handleDownloadFileApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'POST',
                url: 'downloadFile',
                responseType: 'blob'
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }
    const renameFile = () => {
        setIsRenameFileModalOpen(true);
    }

    return (
        <>
            <Toast toast={toastData} resetToast={resetToastData} hasHeader={false}/>

            <MDBDropdown>
                <MDBDropdownToggle color="secondary"><MDBIcon icon="ellipsis-v" /> &nbsp;&nbsp;Action</MDBDropdownToggle>
                <MDBDropdownMenu>
                    <>
                        {(portalType == "user")  && <>
                        <MDBDropdownItem link onClick={editUser} ><MDBIcon icon="edit" />&nbsp;&nbsp; Edit</MDBDropdownItem>
                        <MDBDropdownItem link onClick={deleteUser} ><MDBIcon icon="times-circle" />&nbsp;&nbsp; Delete</MDBDropdownItem>
                        <MDBDropdownItem link onClick={userHistory} ><MDBIcon icon="history" />&nbsp;&nbsp; History</MDBDropdownItem>
                        <MDBDropdownItem link onClick={forgotPassword} ><MDBIcon icon="key" />&nbsp;&nbsp; Forgot Password</MDBDropdownItem>
                        <MDBDropdownItem link onClick={unlockUser} ><MDBIcon icon="unlock" />&nbsp;&nbsp; Unlock</MDBDropdownItem>
                        </>}
                        {(portalType == "userupload")  && <>
                            <MDBDropdownItem link onClick={deleteFileModal} ><MDBIcon icon="trash-alt" />&nbsp;&nbsp; Delete</MDBDropdownItem>
                            <MDBDropdownItem link onClick={downloadFile} ><MDBIcon icon="download" />&nbsp;&nbsp; Download</MDBDropdownItem>
                            <MDBDropdownItem link onClick={renameFile} ><MDBIcon icon="edit" />&nbsp;&nbsp; Rename</MDBDropdownItem>
                        </>}
                    </>
                    </MDBDropdownMenu>
            </MDBDropdown>
            <Suspense fallback={<LoadingOverlay />}>
                {isConfirmDeleteFileModalOpen && (
                    <>
                         <PopConfirm
                            title={"Are you sure to want to delete this File?"}
                            isOpen={isConfirmDeleteFileModalOpen}
                            onConfirm={deleteFileService}
                            onClose={handleModalClose}
                        />
                    </>
                )}
                {isRenameFileModalOpen && (
                    <>
                       <FileRename isOpen={isRenameFileModalOpen} modelClose={()=>setIsRenameFileModalOpen(false)} fileUpdate={updateFile} filename={fileNameWithoutExtension}/>
                    </>
                )}
                {isEditUserModalOpen && (
                    <>
                       <AddUser isOpen={isEditUserModalOpen} onClose={handleModalClose} editMode={true}/>
                    </>
                )}
                {isConfirmDeleteUserModalOpen && (
                    <>
                         <PopConfirm
                            title={"Are you sure to want to delete this user?"}
                            isOpen={isConfirmDeleteUserModalOpen}
                            onConfirm={onConfirmDeleteUser}
                            onClose={handleModalClose}
                        />
                    </>
                )}
                {isConfirmForgotPasswordModalOpen && (
                    <>
                         <PopConfirm
                            title={"Are you sure to send Reset Password Email to user?"}
                            isOpen={isConfirmForgotPasswordModalOpen}
                            onConfirm={forgotPasswordReset}
                            onClose={handleModalClose}
                        />
                    </>
                )}
                {isConfirmLockUnlockModalOpen && (
                    <>
                         <PopConfirm
                            title={"Are you sure to unlock this user?"}
                            isOpen={isConfirmLockUnlockModalOpen}
                            onConfirm={lockUnlockUser}
                            onClose={handleModalClose}
                        />
                    </>
                )}
                {isUserHistoryModalOpen && (
                    <>
                       <UserHistory isOpen={isUserHistoryModalOpen} onClose={handleModalClose} />
                    </>
                )}

            </Suspense>
        </>
    );
};

export default UserAction;
